import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isMobile: false,
  groupTypes: [],
  roles: [],
};

const configSlice = createSlice({
  name: "configSlice",
  initialState,
  reducers: {
    saveMobileView: (state, action) => {
      state.isMobile = action.payload;
    },
    saveGroupTypes: (state, action) => {
      state.groupTypes = action.payload;
    },
    saveRoles: (state, action) => {
      state.roles = action.payload;
    },
  },
});

export const { saveGroupTypes, saveRoles, saveMobileView } = configSlice.actions;
export default configSlice.reducer;
